module.exports = {"Description":"CA : A0A 0A0","RedundantCharacters":" -","ValidationRegex":"^[ABCEGHJKLMNPRSTVXY]\\d[ABCEGHJ-NPRSTV-Z][\\s\\-]?\\d[ABCEGHJ-NPRSTV-Z]\\d$","TestData":{"Valid":["A4B5X5","A4B5A5"],"Invalid":["123AAA","12A5AA"]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/postal-codes-js/formats/CA.json
// module id = 4451
// module chunks = 11